export default{
    configHeadData: [
        {
            title: "纳税人名称",
            prop: "companyName",
            width: "150",
        },
        {
            title: "公司代码",
            prop: "companyCode",
            width: "150",
        },
        {
            title: "类型",
            prop: "type",
            width: "150",
            custom: true
        },
        {
            title: "标题",
            prop: "title",
            width: "150"
        },
        {
            title: "内容",
            prop: "contentDescription",
            width: "550"
        },
        {
            title: "提醒时间",
            prop: "receptionTime",
            width: "150"
        },
    ],
    tablePagination:{
        pageNum: 1,
        pageSize: 50,
        total: 0,
        paginationkey:0
    },
    searchlist:[
        {
            prop: 'companyName',
            label: '纳税人名称',
            type: 'input',
        },
        {
            prop: 'companyCode',
            label: '公司代码',
            type: 'input',
        },
        {
            prop: 'type',
            label: '类型',
            type: 'select',
            selectval: [
                {
                    label: "通知公告",
                    value: "1"
                },
                {
                    label: "风险提示",
                    value: "2"
                },
                {
                    label: "政策速递",
                    value: "3"
                },
                {
                    label: "服务提醒",
                    value: "4"
                },
            ]
        },
        {
            prop: 'title',
            label: '标题',
            type: 'input',
        },
        {
            prop: 'receptionTime',
            label: '提醒时间',
            valueformat: 'yyyy-MM-dd',
            type: 'date',
        },
        {
            prop: 'contentDescription',
            label: '内容',
            type: 'input',
        },
    ],
    searchdata:{
        companyName:'',
        companyCode:"",
        type: "",
        title: "",
        contentDescription: "",
        receptionTime: ""
    }
}
